import { render, staticRenderFns } from "./ProjectEdit.vue?vue&type=template&id=1dffe7f0&scoped=true"
import script from "./ProjectEdit.vue?vue&type=script&lang=js"
export * from "./ProjectEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dffe7f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/print-suite/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1dffe7f0')) {
      api.createRecord('1dffe7f0', component.options)
    } else {
      api.reload('1dffe7f0', component.options)
    }
    module.hot.accept("./ProjectEdit.vue?vue&type=template&id=1dffe7f0&scoped=true", function () {
      api.rerender('1dffe7f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Admin/projects/ProjectEdit.vue"
export default component.exports